module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8n7n2r5n-50a6ef618f8721c46f57a5adc94f2f5b.svg";